// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"04ba32ae","574":"401cd1ba","749":"6a526169","773":"90a636a5","832":"553496f6"}[chunkId] + ".chunk.js";
};